// URL helpers — shared route builders + navigation.
// History-API routing (real URLs like /wespenbestrijding), not hash-routing.
// Pre-rendering depends on this: Google treats #X as an anchor, /X as a page.

// Alle URLs eindigen op trailing slash zodat interne links direct matchen met
// de prerendered file (= 1 hop, geen 308-redirect via Cloudflare's
// directory-slash normalisatie). Sitemap, canonical en redirects gebruiken
// dezelfde trailing-slash conventie.
export const url = {
  home: () => "/",
  diensten: () => "/diensten/",
  werkgebied: () => "/werkgebied/",
  plaag: (slug) => `/${slug}bestrijding/`,
  stad: (stadSlug) => `/werkgebied/${stadSlug}/`,
  stadPlaag: (stadSlug, plaagSlug) => `/${stadSlug}/${plaagSlug}bestrijding/`,
  spoed: () => "/spoedservice/",
  blog: () => "/blog/",
  reviews: () => "/reviews/",
  contact: () => "/contact/",
  offerte: () => "/offerte/",
  privacy: () => "/privacy/",
  cookies: () => "/cookies/",
  voorwaarden: () => "/algemene-voorwaarden/",
  over: () => "/over-ons/",
  horeca: () => "/horeca/",
};

// Programmatic navigation: pushes a new URL and triggers a route update.
// The route hook listens to 'popstate', which pushState doesn't fire — so we
// dispatch one manually after pushing.
export function navigate(path) {
  if (typeof window === 'undefined') return;
  window.history.pushState(null, '', path);
  window.dispatchEvent(new PopStateEvent('popstate'));
}
